import baseURL from "../common/axios";
class LeadStatusService {
  //To Insert LeadStatus-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("LeadStatus/Create", dataModel);
  }
  //To Update LeadStatus-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("LeadStatus/Update", dataModel);
  }
  //To Delete LeadStatus-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("LeadStatus/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "LeadStatus/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get LeadStatus List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("LeadStatus/List");
  }
  //To Get LeadStatus List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("LeadStatus/Get?id=" + Id + "");
  }
}
export default new LeadStatusService();
